<template>
  <div>
    <div>
      <div>
        <mt-cell
          :value="patientList.schedule_id"
          title="订单号"
          class="detail-info"/>
        <mt-cell
          :value="patientList.bill_status"
          title="订单状态"
          class="detail-info"/>
        <mt-cell
          :value="patientList.queue_sn"
          title="就诊序号"
          class="detail-info"/>
        <mt-cell
          :value="patientList.advice_time"
          title="就诊时间"
          class="detail-info"/>
        <mt-cell
          :value="patientList.department"
          title="科室"
          class="detail-info"/>
        <mt-cell
          :value="patientList.doctor_name"
          title="医生"
          class="detail-info"/>
        <!--<mt-cell
          :value="patientList.patient_name"
          title="姓名"
          class="detail-info"/>-->
        <mt-cell
          :value="patientList.bill_id"
          title="ID号"
          class="detail-info"/>
        <!--<mt-cell
          :value="patientList.patient_gender"
          title="性别"
          class="detail-info"/>-->
        <mt-cell
          :value="patientList.patient_phone"
          title="手机号"
          class="detail-info"/>
      </div>
      <div
        v-if="patientList.bill_status !== '已取消'"
        class="btn-toolbar">
        <mt-button
          type="primary"
          size="large"
          @click="cancleBook">取消预约挂号</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { Toast } from 'mint-ui';

export default {
  // 中心医院预约详情页
  name: 'OrderDetail',
  data() {
    return {
      patientList: [],
    };
  },
  created() {
    this.getBookDetial();
  },
  methods: {
    // 预约成功
    init() {
      Toast({
        message: '预约成功',
        position: 'bottom',
        duration: 3000,
      });
    },
    // 取消预约
    async cancleBook() {
      if (this.patientList.bill_status !== '已取消') {
        const config = {
          headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        };
        const params = {
          access_token: Cookies.get('token'),
          schedule_id: this.patientList.schedule_id,
          queue_sn: this.patientList.queue_sn,
          bill_id: this.patientList.bill_id,
        };
        const url = '/new-dpim/webapi/hospital/cancle-book';
        await this.$http.post(url, params, config);
        // this.getBookFuyiDetial();
        Toast({
          message: '取消成功',
          position: 'bottom',
          duration: 3000,
        });
        // this.$router.push({ name: 'ChooseRoom' });
        this.$router.push({ name: 'ChooseRoom', query: { hospitalId: '3' } });
      }
    },
    // 获取中心预约详情
    async getBookDetial() {
      const code = this.$route.query.billCode;
      const params = {
        access_token: Cookies.get('token'),
        bill_code: code,
      };
      const url = '/new-dpim/webapi/hospital/get-book-info-one';
      const response = await this.$http.get(url, { params });
      this.patientList = response.item;
      if (this.patientList.bill_status !== '已取消') {
        this.init();
      }
    },
  },
};
</script>

<style scoped>
  .detail-info {
    border-bottom: 1px solid #dee2e6;
  }
  .btn-toolbar {
    padding: 20px 10px 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/appointment/order-detail.vue